import { types, getParent, onSnapshot } from 'mobx-state-tree';
import { values } from 'mobx'
import shortid from 'shortid';
import { rootStore } from '../index';

export const CustomerReference = types.reference(types.late(() => Customer), {
  get(identifier, parent) {
    const customer = values(rootStore.customers).find(c => c.id === identifier)
    if (!customer) {
      rootStore.loadCustomer(identifier)
      return { id: identifier, name: 'Loading...' }
    }
    return customer

  },
  set(value) {
    return value.id
  }
})

const Customer =  types
  .model({
    id: types.identifier(types.string),
    name: '',
    code: '',
    contact: '',
    email: '',
    phone: '',
    fax: '',
    physicalAddress: '',
    postalAddress: '',
    comment: '',
  })
  .preProcessSnapshot(snapshot => {
    const copy = Object.assign(snapshot)
    if (!copy.id) copy.id = shortid.generate()
    return copy
  })
  .actions(self => ({
    afterAttach() {
      onSnapshot(self, snapshot => {
        getParent(self, 2).saveItem(self)
      })
    },
    save() {
      getParent(self, 2).saveItem(self)
    },
    setName(string) { self.name = string },
    setCode(string) { self.code = string },
    setContact(string) { self.contact = string },
    setEmail(string) { self.email = string },
    setPhone(string) { self.phone = string },
    setFax(string) { self.fax = string },
    setPhysicalAddress(string) { self.physicalAddress = string },
    setPostalAddress(string) { self.postalAddress = string },
    setComment(string) { self.comment = string },
    remove() {
      getParent(self, 2).removeCustomer(self)
    }
  }))
  .views(self => ({
    get isValid() {
      return self.name.length > 0
    }
  }))

export default Customer;


// WEBPACK FOOTER //
// ./src/models/Customer.js